// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio__categories {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.btn.cat__btn {
  text-transform: capitalize;
  transition: var(--transition);
}

.btn.cat__btn:hover {
  transform: translateY(0);
}

.portfolio__projects {
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  align-self: start;
}

.card.portfolio__project {
  animation: animateProject 800ms ease-in forwards;
  display: flex;
  flex-direction: column;
  height: 100%;
}

@keyframes animateProject {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.portfolio__project-image {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 8rem;
  max-height: 15rem;
  background: var(--color-light);
  border-radius: var(--border-radius-2);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.portfolio__project p {
  margin: 0.5rem 0 2rem;
  flex-grow: 1;
}

.portfolio__project-cta {
  display: flex;
  gap: 1rem;
  margin-top: auto;
  justify-content: center;
}

.portfolio__project:hover .btn.sm {
  border-color: var(--color-white);
}

.portfolio__project:hover .btn.sm.primary {
  background: transparent;
  border-color: var(--color-primary);
  color: var(--color-primary);
}

/* Media queries tablets */

@media screen and (max-width: 1024px) {
  .portfolio__projects {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

/* Media queries phone */

@media screen and (max-width: 600px) {
  .portfolio__categories {
    gap: 0.6rem;
  }

  .btn.cat__btn {
    padding: 0.7rem 0.8rem;
  }

  .portfolio__projects {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/portfolio/portfolio.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,wBAAwB;;AAExB;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF","sourcesContent":[".portfolio__categories {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.btn.cat__btn {\n  text-transform: capitalize;\n  transition: var(--transition);\n}\n\n.btn.cat__btn:hover {\n  transform: translateY(0);\n}\n\n.portfolio__projects {\n  margin-top: 3rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 3rem;\n  align-self: start;\n}\n\n.card.portfolio__project {\n  animation: animateProject 800ms ease-in forwards;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n@keyframes animateProject {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.portfolio__project-image {\n  width: 100%;\n  height: fit-content;\n  min-height: 8rem;\n  max-height: 15rem;\n  background: var(--color-light);\n  border-radius: var(--border-radius-2);\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n}\n\n.portfolio__project p {\n  margin: 0.5rem 0 2rem;\n  flex-grow: 1;\n}\n\n.portfolio__project-cta {\n  display: flex;\n  gap: 1rem;\n  margin-top: auto;\n  justify-content: center;\n}\n\n.portfolio__project:hover .btn.sm {\n  border-color: var(--color-white);\n}\n\n.portfolio__project:hover .btn.sm.primary {\n  background: transparent;\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n/* Media queries tablets */\n\n@media screen and (max-width: 1024px) {\n  .portfolio__projects {\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n  }\n}\n\n/* Media queries phone */\n\n@media screen and (max-width: 600px) {\n  .portfolio__categories {\n    gap: 0.6rem;\n  }\n\n  .btn.cat__btn {\n    padding: 0.7rem 0.8rem;\n  }\n\n  .portfolio__projects {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
